export interface HeaderLanguageToggleEventDetails {
	oldLanguage: string;
	newLanguage: string;
}
